import React, { useEffect, useState } from 'react'
import { RiShoppingCart2Fill } from 'react-icons/ri'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import LoadingSpinner from '../LoadingSpinner'

import { FaEye } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'
import { socket } from '../../utils/utils'
import { get_customer_dashboard_data } from '../../store/reducers/orderReducer'

const Index = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const { userInfo } = useSelector((state) => state.auth)
  const {recentOrders, totalOrder, pendingOrder, deliveredOrder } =
    useSelector((state) => state.order)
    
  const [loading, setLoading] = useState(true)




  useEffect(() => {
    dispatch(get_customer_dashboard_data(userInfo?.id))
    
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [])


  useEffect(() => {
    socket.on('orderStatusUpdate', (data) => {
      dispatch(get_customer_dashboard_data(userInfo?.id))
    })
  }, [])

  const redirect = (ord) => {
    let items = 0
    for (let i = 0; i < ord.length; i++) {
      items = ord.products[i].quantity + items
    }
    navigate('/payment', {
      state: {
        price: ord.price,
        items,
        orderId: ord._id,
      },
    })
  }

  return (
    <div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div>
          <div className="grid grid-cols-3 md:grid-cols-1 gap-3">
            <div className="flex  p-3 border bg-white rounded-md gap-3">
              <div className="bg-primary w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl">
                <span className="text-xl text-white">
                  <RiShoppingCart2Fill />
                </span>
              </div>
              <div className="flex flex-col justify-start items-start text-slate-600">
                <h2 className="text-3xl font-bold">{totalOrder}</h2>
                <span>{t('orderS.total_orders')} </span>
              </div>
            </div>

            <div className="flex p-3 border bg-white rounded-md gap-3">
              <div className="bg-[#f7d93f] w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl">
                <span className="text-xl text-black">
                  <RiShoppingCart2Fill />
                </span>
              </div>
              <div className="flex flex-col justify-start items-start text-slate-600">
                <h2 className="text-3xl font-bold">{pendingOrder}</h2>
                <span>{t('orderS.pending_orders')}</span>
              </div>
            </div>

            <div className="flex  p-3 border bg-white rounded-md gap-3">
              <div className="bg-green-100 w-[47px] h-[47px] rounded-full flex justify-center items-center text-xl">
                <span className="text-xl text-green-800">
                  <RiShoppingCart2Fill />
                </span>
              </div>
              <div className="flex flex-col justify-start items-start text-slate-600">
                <h2 className="text-3xl font-bold">{deliveredOrder}</h2>
                <span>{t('orderS.delivered_orders')}</span>
              </div>
            </div>
          </div>

          <div className="bg-white p-5 mt-5 rounded-md">
            <h2> {t('dashboardS.recent_orders')}</h2>
            <div className="pt-4">
              <div className="relative overflow-x-auto rounded-md">
                <table
                  className={`w-full text-sm ${
                    isRTL ? 'text-right' : 'text-left'
                  }   text-gray-700`}
                >
                  <thead className="text-sm text-gray-700 uppercase bg-gray-200">
                    <tr>
                      <th scope="col" className="py-3 px-4">
                        {t('dashboardS.no')}
                      </th>
                      <th scope="col" className="px-6 py-3">
                        {' '}
                        {t('orderS.order_id')}
                      </th>
                      <th scope="col" className="px-6 py-3">
                        {t('products.price')}
                      </th>
                      <th scope="col" className="px-6 py-3">
                        {t('dashboardS.payment_status')}
                      </th>
                      <th scope="col" className="px-6 py-3">
                        {t('orderS.order_status')}
                      </th>
                      <th scope="col" className="px-6 py-3">
                        {t('orderS.order_date')}
                      </th>

                      <th scope="col" className="px-6 py-3">
                        {t('dashboardS.action')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {recentOrders?.map((o, i) => (
                      <tr key={i} className="bg-white border-b">
                        <td className="py-2 px-4  whitespace-nowrap">
                          {i + 1}
                        </td>
                        <td className="px-6 py-4 font-medium whitespace-nowrap">
                          #{o.orderNumber}
                        </td>
                        <td className="px-6 py-4 font-medium whitespace-nowrap">
                          {o.price} {t('products.currency')}
                        </td>
                        <td className="px-6 py-4 font-medium whitespace-nowrap">
                          <span
                            className={`${
                              o.payment_status !== 'paid'
                                ? 'bg-red-200'
                                : 'bg-green-200'
                            } text-gray-700 text-md font-semibold mr-2 px-3 py-[2px] rounded `}
                          >
                            {o.payment_status}
                          </span>
                        </td>
                        <td className="px-6 py-4 font-medium whitespace-nowrap">
                          {t(`orderS.${o.delivery_status}`)}
                        </td>
                        <td className="py-2 px-4 whitespace-nowrap">
                          {o.createdAt.slice(0, 10)}
                        </td>
                        <td className="px-6 py-4 font-medium whitespace-nowrap">
                          <Link to={`/dashboard/order/details/${o._id}`}>
                            {/* <span className=" text-md font-semibold mr-2 px-3 py-[2px] rounded"> */}
                            <FaEye size={24} color="#3e73ce" /> {/* </span> */}
                          </Link>

                          {/* {o.payment_status !== 'paid' && (
                                  <span
                                    onClick={() => redirect(o)}
                                    className="bg-green-200 text-green-800 text-md font-semibold mr-2 px-3 py-[2px] rounded cursor-pointer"
                                  >
                                    Pay Now
                                  </span>
                                )} */}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Index
